// モックアップ共有（doc/design/pm-mockup.md）
export default {
  'mockup.tab': '效果图',
  'mockup.empty': '暂无效果图',
  'mockup.chip.internal': '仅内部',
  'mockup.chip.shared': '分享中',
  'mockup.chip.sharedUntil': '分享中 · 至 {date}',
  'mockup.col.title': '标题',
  'mockup.col.linked': '关联对象',
  'mockup.col.version': '版本',
  'mockup.col.share': '分享',
  'mockup.col.updated': '更新',
  'mockup.linked.task': '任务',
  'mockup.linked.bug': 'Bug',
  'mockup.linked.project': '仅项目',
  'mockup.deleteConfirm': '删除「{title}」吗？',
  'mockup.deleteHint': '所有版本都会被删除，分享链接也会失效。',
  'mockup.edit.title': '编辑效果图',
  'mockup.edit.task': '关联任务',
  'mockup.edit.taskHint': '留空则挂在整个项目上。内容的修改请作为新版本发布。',
  'mockup.edit.clearBug': '解除与 Bug {bug} 的关联',
  'mockup.field.title': '标题',
  'mockup.field.titlePlaceholder': '留空则使用 HTML 的 title 标签',
  'mockup.field.note': '版本说明',
  'mockup.field.notePlaceholder': '例：根据客户反馈增加保留状态',
  'mockup.page.title': '效果图',
  'mockup.page.titleOf': '{name} · 效果图',
  'mockup.page.subtitle':
    '管理用 Claude Code 等生成的 HTML 效果图版本，并分享给客户和营业',
  'mockup.page.sharedOnly': '只看分享中',
  'mockup.page.upload': '上传 HTML / zip',
  'mockup.page.entry': '效果图一览',
  'mockup.upload.title': '发布效果图',
  'mockup.upload.newVersion': '上传新版本',
  'mockup.upload.publish': '发布',
  'mockup.upload.drop': '拖入 HTML 或 zip 文件，或点击选择',
  'mockup.upload.hint': '.html（最大 5MB）或含图片等资源的 .zip（最大 50MB）',
  'mockup.upload.needFile': '请选择 HTML 或 zip 文件',
  'mockup.upload.done': '已发布 v{v}',
  'mockup.upload.error.type': '只能上传 .html 或 .zip 文件',
  'mockup.upload.error.size':
    '不能上传超过 5MB 的 HTML，请把图片等资源拆出来打成 zip',
  'mockup.upload.error.zipSize': '不能上传超过 50MB 的 zip',
  'mockup.upload.error.empty': '文件为空',
  'mockup.viewer.close': '关闭',
  'mockup.viewer.desktop': '桌面',
  'mockup.viewer.tablet': '平板',
  'mockup.viewer.phone': '手机',
  'mockup.viewer.openTab': '新窗口打开',
  'mockup.viewer.newVersion': '新版本',
  'mockup.viewer.share': '分享…',
  'mockup.viewer.loading': '加载中…',
  'mockup.viewer.slow': '加载时间较长，请稍候。',
  'mockup.version.files': '{n} 个文件',
  'mockup.version.title': '版本',
  'mockup.version.deleteConfirm': '删除 v{v} 吗？',
  'mockup.version.deleteHint': '删除当前版本后，剩余的最新版本会成为当前版本。',
  'mockup.version.shareLatest': '分享链接总是显示最新版本。',
  'mockup.version.sharePinned': '分享链接固定显示 v{v}。',
  'mockup.version.notShared': '尚未开启分享链接。',
  'mockup.share.title': '分享「{title}」',
  'mockup.share.enable': '开启分享链接',
  'mockup.share.offHint': '开启后会生成无需登录即可查看的链接（默认 30 天）。',
  'mockup.share.link': '链接（无需登录）',
  'mockup.share.copy': '复制',
  'mockup.share.copied': '已复制',
  'mockup.share.copyFailed': '复制失败',
  'mockup.share.expiry': '有效期',
  'mockup.share.days7': '7 天',
  'mockup.share.days30': '30 天',
  'mockup.share.never': '无期限',
  'mockup.share.until': '至 {date}',
  'mockup.share.noExpiry': '无期限',
  'mockup.share.version': '对方看到的版本',
  'mockup.share.latest': '总是最新',
  'mockup.share.pinTo': '固定为 v{v}',
  'mockup.share.views': '已打开 {n} 次 · 最近 {last}',
  'mockup.share.regenerate': '重新生成链接',
  'mockup.share.regenerateConfirm': '重新生成链接吗？',
  'mockup.share.regenerateHint': '当前链接会立即失效，请把新链接重新发给对方。',
  'mockup.share.regenerated': '已生成新链接',
  'mockup.share.done': '完成',
  'mockup.public.invalid': '此链接已失效，请联系负责人。',
  'mockup.public.version': '版本 {v} · {date} 更新',
  'mockup.public.validUntil': '{date} 前有效',
};
